module.exports = __webpack_public_path__ + "img/108516c.jpg";